import React, { useState } from "react";
import useSWR from 'swr';
import fetcher from "../../utils/fetcher";
//import InvestorCards from "../../components/InvestorCards";
import { Helmet } from "react-helmet";
// import Pagination from "react-js-pagination";
import "../../components/InvestorCards/style.css"

const Investor = () => {
  const { data } = useSWR('https://api.testworks.co.kr/investors?_sort=id:DESC', fetcher);

  const postsPerPage = 5;
  const [next, setNext] = useState(postsPerPage);
  const handleMorePosts = () => {
    setNext(next + 5);
  };

  return (
    <>
      <Helmet>
        <title>에이아이웍스 – 에이아이웍스의 Investor Relations</title>
        <meta name='description' content='에이아이웍스가 어떻게 기술 기반의 성장을 넘어 더 나은 사회를 위한 변화된 가치를 창출해 내는지 알아보세요.' />
      </Helmet>
      <div className="visualWrap investorVisual">
        <div className="inner">
          <div className="tit_wrap">
            <div className="flex_col">
              <h2>Investor Relations</h2>
              <p>에이아이웍스가 어떻게 기술 기반의 성장을 넘어 더 나은 사회를 위한 변화된 가치를 창출해 내는지 알아보세요</p>
            </div>
          </div>
        </div>
      </div>
      <div className="investor">
        <p className="subText"><span>에이아이웍스</span>는 SW 검증 노하우와 AI 전문성을 결합하여 인공지능 산업에서 데이터 수집-가공-검수-모델개발-검증에 이르는 전 과정에서 품질을 기반으로 고객의 성공적인 비즈니스를 지원합니다. 또한 공공 기관, 기업 및 소셜벤처와의 협업을 통해 사회 문제 해결 활동 등에 적극 참여하며 지속 가능한 사회 성장을 위한 실천을 하고 있습니다. 에이아이웍스는 다양성과 포용적 고용을 지향하며 기술 혁신과 성장을 통해 더 나은 사회를 위한 가치 창출에 기여하고자 합니다.</p>
        <h2>주주총회</h2>

        {data ? (
          <div className="investorList">
            {data && (
              data?.slice(0, next)?.map((post) => (
                <a href={post.contents}
                className="investorCard"
                target="_blank"
                rel="noreferrer">
                  <div className="sub">
                    <span className="investorDay">{post.notiday}</span>
                    <span className="investoTitle">주주총회 공고</span>
                  </div>
                  <span className="link">내용보기</span>
                </a>
              ))
            )}
            {next < data?.length && (
              <button
                className="more"
                onClick={handleMorePosts}>
                더보기
              </button>
            )}
          </div>
        ) : (
          <div className="loading">Loading...</div>
        )}
        <div className="esg">
          <p>
            <span className="pc_br">ESG의 &lsquo;S&rsquo;는 다양성에 기반하며</span>
            <span className="pc_br">다양성을 인정하는 것에서 창의력이 시작되고,</span>
            <span className="pc_br">그것이 경쟁력을 의미합니다.</span>
            <br />
            <span className="pc_br">기술과 사람의 다양성이 보장되어야</span>
            <span className="pc_br">비로서 지속 성장이 가능하며 기업 경쟁력을 갖출 수 있습니다.</span>
            <br /><br />
            <span className="ceo">윤석원 에이아이웍스 창업자 & CEO</span>
          </p>
        </div>
      </div>
    </>
  )
}

export default Investor;